import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../../data-provider/campaign.dp";
import { Campaign } from "../../../models/campaign.model";
import { ProductDataProvider } from "../../../data-provider/product.dp";
import { DialogUtils } from "../../../helper/dialog.helper";
import { UserDataProvider } from "../../../data-provider/user.dp";
import { Limit } from "../../../models/limit.model";
import { LimitDataProvider } from "../../../data-provider/limit.dp";

let SeatsSettingsDialogComponent = {
    selector: "vcSeatsSettingsDialog",
    templateUrl:
        "/angular/components/user/seats/seats-settings-dialog.component.html",
    bindings: {},
    controller: class SeatsSettingsDialog {
        private dialog: DialogUtils;

        public activeCampaign: Campaign;
        public limits: Limit;
        public min: number;
        public product: object;
        public new: object;

        constructor(
            CampaignDataProvider: CampaignDataProvider,
            LimitDataProvider: LimitDataProvider,
            UserDataProvider: UserDataProvider,
            ProductDataProvider: ProductDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.new = {};
            this.dialog = DialogUtils;

            LimitDataProvider.get().then((limits: Limit) => {
                this.limits = limits;
                UserDataProvider.getUsersCount().then((counts: any) => {
                    let superUsers: number =
                        counts.superusers + counts.superinvites;
                    this.min =
                        superUsers -
                        (this.limits.superusers + this.limits.extrasuperusers);
                    this.min = this.min > 0 ? this.min : 0;

                    this.new["licences"] =
                        this.min > 0 ? this.min : this.limits.extrasuperusers;
                });
            });

            ProductDataProvider.all().then((products: object) => {
                this.product = ProductDataProvider.getUserLicenseProduct(
                    this.activeCampaign,
                    products
                );
            });
        }

        confirm(): void {
            if (this.new["licences"] != this.limits.extrasuperusers) {
                this.dialog.hide(
                    this.new["licences"] - this.limits.extrasuperusers
                );
            } else {
                this.dialog.cancel();
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("seats", [])
    .component(
        SeatsSettingsDialogComponent.selector,
        SeatsSettingsDialogComponent
    );
